var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"custom-quiz-tile-container",on:{"click":_vm.tileClicked}},[_c('icon',{staticClass:"create-icon",attrs:{"name":"cross","variant":"7b7b7b"}}),_vm._v("\n  Create Quiz\n  "),(_vm.locked)?_c('div',{staticClass:"lock"},[_c('icon',{staticClass:"lock-icon",attrs:{"name":"lock","variant":'white'}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }